import Cookies from 'js-cookie'
import config from '@/config'
const { cookieExpires } = config

export const TOKEN_KEY = 'leave_token'
export const USER_INFO = 'leave_userinfo'
export const FEEDBACK_DETAIL = 'leave_feedbackdetail'
export const newWin = (url, id = getUuid()) => {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', id)
  // 防止反复添加
  if (!document.getElementById(id)) document.body.appendChild(a)
  a.click()
}
export const getUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0
    var v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}
export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}
export const delToken = () => {
  Cookies.remove(TOKEN_KEY)
}

export const getUserInfo = () => {
  const userInfo = Cookies.get(USER_INFO)
  if (userInfo) return JSON.parse(userInfo)
  else return false
}

export const setUserInfo = (userInfo) => {
  Cookies.set(USER_INFO, userInfo, { expires: cookieExpires || 1 })
}
export const delUserInfo = () => {
  Cookies.remove(USER_INFO)
}

export const getFeedbackDetail = () => {
  const feedbackDetail = Cookies.get(FEEDBACK_DETAIL)
  if (feedbackDetail) return JSON.parse(feedbackDetail)
  else return false
}

export const setFeedbackDetail = (feedbackDetail) => {
  Cookies.set(FEEDBACK_DETAIL, feedbackDetail, { expires: cookieExpires || 1 })
}
export const delFeedbackDetail = () => {
  Cookies.remove(FEEDBACK_DETAIL)
}

// 去除链接中的code和state
export const cleanAuthParams = (query) => {
  const newQuery = { ...query }
  delete newQuery.code
  delete newQuery.state
  return newQuery
}
